export const timeZone = {
  'America/Chicago': '-06:00',
  'America/Denver': '-07:00',
  'America/Detroit': '-05:00',
  'America/Indiana/Indianapolis': '-05:00',
  'America/Indiana/Knox': '-06:00',
  'America/Indiana/Marengo': '-05:00',
  'America/Indiana/Petersburg': '-05:00',
  'America/Indiana/Tell_City': '-06:00',
  'America/Indiana/Vevay': '-05:00',
  'America/Indiana/Vincennes': '-05:00',
  'America/Indiana/Winamac': '-05:00',
  'America/Indianapolis': '-05:00',
  'America/Juneau': '-09:00',
  'America/Kentucky/Louisville': '-05:00',
  'America/Kentucky/Monticello': '-05:00',
  'America/Knox_IN': '-06:00',
  'America/Los_Angeles': '-08:00',
  'America/Louisville': '-05:00',
  'America/Menominee': '-06:00',
  'America/Metlakatla': '-09:00',
  'America/Montevideo': '-03:00',
  'America/New_York': '-05:00',
  'America/Nome': '-09:00',
  'America/North_Dakota/Beulah': '-06:00',
  'America/North_Dakota/Center': '-06:00',
  'America/North_Dakota/New_Salem': '-06:00',
  'America/Phoenix': '-07:00',
  'America/Puerto_Rico': '-04:00',
  'America/Shiprock': '-07:00',
  'America/Sitka': '-09:00',
  'America/Yakutat': '-09:00',
  'Asia/Almaty': '+06:00',
  'Asia/Aqtobe': '+05:00',
  'Asia/Ashgabat': '+05:00',
  'Asia/Atyrau': '+05:00',
  'Asia/Baku': '+04:00',
  'Asia/Colombo': '+05:30',
  'Asia/Dubai': '+04:00',
  'Asia/Hong_Kong': '+08:00',
  'Asia/Pyongyang': '+09:00',
  'Asia/Qatar': '+03:00',
  'Asia/Seoul': '+09:00',
  'Asia/Shanghai': '+08:00',
  'Asia/Singapore': '+08:00',
  'Asia/Tbilisi': '+04:00',
  'Asia/Tokyo': '+09:00',
  'Asia/Vladivostok': '+11:00',
  'Australia/Melbourne': '+11:00',
  'Europe/Amsterdam': '+01:00',
  'Europe/Athens': '+02:00',
  'Europe/Belfast': '+00:00',
  'Europe/Belgrade': '+01:00',
  'Europe/Berlin': '+01:00',
  'Europe/Bratislava': '+01:00',
  'Europe/Brussels': '+01:00',
  'Europe/Bucharest': '+02:00',
  'Europe/Budapest': '+01:00',
  'Europe/Chisinau': '+02:00',
  'Europe/Copenhagen': '+01:00',
  'Europe/Dublin': '+00:00',
  'Europe/Helsinki': '+02:00',
  'Europe/Kaliningrad': '+02:00',
  'Europe/Kiev': '+02:00',
  'Europe/Lisbon': '+00:00',
  'Europe/Ljubljana': '+01:00',
  'Europe/London': '+00:00',
  'Europe/Luxembourg': '+01:00',
  'Europe/Madrid': '+01:00',
  'Europe/Malta': '+01:00',
  'Europe/Minsk': '+03:00',
  'Europe/Monaco': '+01:00',
  'Europe/Moscow': '+03:00',
  'Europe/Oslo': '+01:00',
  'Europe/Paris': '+01:00',
  'Europe/Podgorica': '+01:00',
  'Europe/Prague': '+01:00',
  'Europe/Riga': '+02:00',
  'Europe/Rome': '+01:00',
  'Europe/San_Marino': '+01:00',
  'Europe/Sarajevo': '+01:00',
  'Europe/Skopje': '+01:00',
  'Europe/Stockholm': '+01:00',
  'Europe/Tallinn': '+02:00',
  'Europe/Tiraspol': '+02:00',
  'Europe/Vaduz': '+01:00',
  'Europe/Vatican': '+01:00',
  'Europe/Vilnius': '+02:00',
  'Europe/Warsaw': '+01:00',
  'Europe/Zagreb': '+01:00',
  Iceland: '+00:00',
  'Indian/Maldives': '+05:00',
  Israel: '+02:00',
  Turkey: '+03:00',
  'US/Arizona': '-07:00',
  'US/Central': '-06:00',
  'US/East-Indiana': '-05:00',
  'US/Eastern': '-05:00',
  'US/Hawaii': '-10:00',
  'US/Indiana-Starke': '-06:00',
  'US/Michigan': '-05:00',
  'US/Mountain': '-07:00',
  'US/Pacific': '-08:00',
} as const
